import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { getHttpHeader } from './../../utils/http-header.factory';
import { BaseService } from '../../templates/services/base-service.template';
import { Core2Config } from './../../utils/core2-config';
import { ApiResponseModel } from './../../models/base/api-response.model';
import { ApiVisa } from './../../models/base/apivisa.model';

@Injectable({
    providedIn: 'root'
})
export class MstLinkSubjectService implements BaseService {

    public readonly apiUrl: string = Core2Config.TENANT_CUSTOM_URL_PREFIX + Core2Config.UNIPIN_PREFIX + 'shared/get-app-mst-link-subject-to-role-guid';

    constructor(protected readonly http: HttpClient) {}

    public getLink(roleGuid: string, keyword: string, { api_domain_url, jwt_secret, tenantCode }: ApiVisa): Observable<ApiResponseModel<string[]>>{
        return this.http.get<ApiResponseModel<string[]>>(`${ api_domain_url }${ this.apiUrl }?app_mst_role_guid=${ roleGuid }${ keyword? `&keyword=${ keyword }` : '' }`, getHttpHeader(jwt_secret, tenantCode));
    }
}
